<template>
    <div class="account-input-territories">
        <v-autocomplete
            v-if="!select || select.type != 'code'"
            v-model="select"
            :items="items.length ? items : this.territories"
            :search-input.sync="search"
            label="Département"
            hide-selected
            append-icon="mdi-chevron-down"
            item-text="code"
            item-value="code"
            return-object
            :no-filter="true"
            no-data-text=""
            :multiple="false"
            :clearable="true"
        >
            <template slot="selection" slot-scope="data">
                <div class="account-suggest selected" v-if="data.item">
                    <typo name="body-10-normal" class="code">{{ data.item.code }} </typo>
                    <typo name="body-14-medium">{{ data.item.label }}</typo>
                </div>
            </template>
            <template slot="item" slot-scope="data">
                <div class="account-suggest">
                    <typo name="body-10-normal" class="code">{{ data.item.code }}</typo>
                    <typo name="body-14-light" v-html="highlight(data.item.label, search)" />
                </div>
            </template>
        </v-autocomplete>
    </div>
</template>

<script>
import { Services } from "src/services/Services";
import { filter, find, trim } from "lodash";
import { highlight } from "src/utils/highlight";

export default {
    props: ["value"],
    data() {
        return {
            select: null,
            search: null,
            items: [],
        };
    },
    methods: {
        highlight(string) {
            return trim(highlight(string, this.search));
        },
        clean(string) {
            if (string) return string.replace(/[-_ ]/, "").toLowerCase();
            return string;
        },
    },
    watch: {
        search() {
            const items = filter(
                this.territories,
                t =>
                    t.code.indexOf(this.search) > -1 ||
                    this.clean(t.label).indexOf(this.clean(this.search)) > -1
            );
            this.items = items;
        },
        select() {
            this.search = "";
            if (this.select && this.select.code) {
                this.$emit("input", this.select.code);
            } else {
                this.$emit("input", "");
            }
        },
        territories() {
            if (this.value) {
                const item = find(this.territories, t => t.code === this.value);
                if (item) this.select = item;
            }
        },
    },
    asyncComputed: {
        async territories() {
            const territories = await Services.api.ca.getAllTerritories();
            return filter(territories, t => t.code != "all" && t.code != "met");
        },
    },
};
</script>

<style lang="sass">

.account-suggest
    display: flex
    flex-direction: row
    .code
        background: black
        margin-right: 10px
        padding: 0 5px
        text-align: center
        color: white
        display: inline-block
        text-transform: uppercase
        min-width: 30px
        line-height: 10px
        display: flex
        align-items: center
        align-content: center
        justify-content: center
    .highlight
        background: transparentize($color-main, 0.8)

.account-suggest.selected
    .code
        background: $color-secondary
        color: white
        padding: 0 3px
        width: auto
</style>
